import { stashCredentialsFromUrl } from 'utils/credentialUrl';
import axiosSetup from './axiosSetup';
import debugSetup from './debugSetup';
// import setupHubspot from './setupHubspot';
// import setupUserGuiding from './setupUserGuiding';
// import setupGoogleAnalytics from './setupGoogleAnalytics';

export default function setup() {
  // Must precede debugSetup so SDKs never see credentials in the URL
  stashCredentialsFromUrl();
  axiosSetup();
  debugSetup();
  // setupHubspot();
  // setupUserGuiding();
  // setupGoogleAnalytics();
}
